import { jwtDecode } from "jwt-decode";
import { MyJwtPayload } from "../../types/types";
import { UserRole, UserRoles } from "./types";

const adminRole: UserRole = "sdlp-superadmin";
const pilotRole: UserRole = "pilote";
const basicRole: UserRole = "sdlp-user";
const performerRole: UserRole = "performer";

const decodeAccessToken = (accessToken: string) => {
  const jwtPayload = jwtDecode(accessToken) as MyJwtPayload;
  return jwtPayload;
};

export const getRole = (userRoles: UserRoles): UserRole => {
  if (isAdmin(userRoles)) return adminRole;
  if (isPilot(userRoles)) return pilotRole;
  if (isPerformer(userRoles)) return performerRole;
  return basicRole;
};

export const extractRoles = (accessToken: string): UserRoles => {
  const jwtPayload = decodeAccessToken(accessToken);

  console.log("jwtPayload", jwtPayload);

  // Happened for "user" roles
  if (!jwtPayload.resource_access["SDLP-EVT"]) {
    return ["sdlp-user"];
  }

  return jwtPayload.resource_access["SDLP-EVT"].roles;
  // return ["sdlp-superadmin", "pilote", "sdlp-user"] as UserRoles;
};

export const extractHigherRole = (accessToken: string): UserRole => {
  const r = extractRoles(accessToken);
  return getRole(r);
};

export const isAdmin = (roleOrRoles: null | UserRole | UserRoles) => {
  if (!roleOrRoles) {
    return false;
  }
  if (typeof roleOrRoles === "string") {
    return roleOrRoles === adminRole;
  }
  return roleOrRoles.includes(adminRole);
};

export const isPilot = (roleOrRoles: null | UserRole | UserRoles) => {
  if (!roleOrRoles) {
    return false;
  }
  if (typeof roleOrRoles === "string") {
    return roleOrRoles === pilotRole;
  }
  return roleOrRoles.includes(pilotRole);
};

export const isBasic = (roleOrRoles: null | UserRole | UserRoles) => {
  if (!roleOrRoles) {
    return false;
  }
  if (typeof roleOrRoles === "string") {
    return roleOrRoles === basicRole;
  }
  return roleOrRoles.includes(basicRole);
};

export const isPerformer = (roleOrRoles: null | UserRole | UserRoles) => {
  if (!roleOrRoles) {
    return false;
  }
  if (typeof roleOrRoles === "string") {
    return roleOrRoles === performerRole;
  }
  return roleOrRoles.includes(performerRole);
};
